import { render } from "./WXQRCode.vue?vue&type=template&id=00e46768&scoped=true"
import script from "./WXQRCode.vue?vue&type=script&lang=js"
export * from "./WXQRCode.vue?vue&type=script&lang=js"

import "./WXQRCode.vue?vue&type=style&index=0&id=00e46768&lang=less&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e46768"]])

export default __exports__